module.exports = __webpack_public_path__ + "img/close.16f66fd4.png";